import qs from 'qs';
import { IsCancelNetworkError, IsNetworkError, NetworkErrorProps, NetworkPromise, NetworkRequestConfig } from './types';
import { GET_Axios, isCancelNetworkError_Axios, isNetworkError_Axios, POST_Axios } from './adapters/api';
import {
	addAbortControllerToMemory,
	getDefaultGETHeaders,
	getNewAbortController,
} from '../../modules/app/network/utils';
import { PAGE_CONTENT_REQUEST_HEADER } from '../../modules/app/const';
import { isUndefined } from '../../predicates/type';

export const isNetworkError: IsNetworkError = <T>(error: unknown): error is NetworkErrorProps<T> => {
	return isNetworkError_Axios(error);
};

export const isCancelNetworkError: IsCancelNetworkError = (payload) => {
	return isCancelNetworkError_Axios(payload);
};

type GETConfig = NetworkRequestConfig & {
	pageContentRequestHeader?: boolean;
	cancelId?: string;
};
export type Get = <T = unknown>(url: string, config?: GETConfig) => NetworkPromise<T>;
export const GET: Get = <T = unknown>(url, config?): NetworkPromise<T> => {
	if (typeof config !== 'object') {
		config = {};
	}

	const { pageContentRequestHeader, cancelId, ...axiosConfig } = config;

	if (typeof config.data !== 'undefined') {
		throw '[data] prop is only for POST, please replace with [params] prop!';
	}

	axiosConfig.paramsSerializer = {
		serialize: (params) => {
			return qs.stringify(params, {
				arrayFormat: 'comma',
				allowDots: true,
			});
		},
	};

	const headers = {
		...getDefaultGETHeaders(),
		[PAGE_CONTENT_REQUEST_HEADER]: !!pageContentRequestHeader,
	};
	const abortController = getNewAbortController();

	if (!isUndefined(abortController)) {
		addAbortControllerToMemory(abortController, cancelId);
		axiosConfig.signal = abortController.signal;
	}

	// @ts-ignore
	return GET_Axios(url, {
		headers,
		...axiosConfig,
	});
};

export type CustomAxiosPromise<T> = NetworkPromise<T> & {
	cancel?: (cancelReason?: string) => void;
};
export type POSTConfig = NetworkRequestConfig & {
	isCancellable?: boolean;
	cancelId?: string;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const POST = <T = any>(url: string, config?: POSTConfig): CustomAxiosPromise<T> => {
	if (typeof config !== 'object') {
		config = {};
	}

	const { isCancellable, cancelId, ...axiosConfig } = config;
	const { data, ...otherConfig } = axiosConfig;
	const headers = {
		...getDefaultGETHeaders(),
	};

	if (isCancellable) {
		const abortController = getNewAbortController();

		if (!isUndefined(abortController)) {
			addAbortControllerToMemory(abortController, cancelId);
			otherConfig.signal = abortController.signal;
		}
	}

	// @ts-ignore
	return POST_Axios(url, data, {
		headers,
		...otherConfig,
	});
};
